import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Alert, Button, Heading } from '@innovationnorway/cl-react';
import { OneWayInServiceDto, OneWayInServiceProviderDto } from 'src/api/v2';
import ServiceTable from '../ServiceTable';

interface SelectServicesStepProps {
  referTo: OneWayInServiceProviderDto;
  actorAlreadyHasOpportunity: boolean;
  isLoading: boolean;
  selectedServices: OneWayInServiceDto[];
  setSelectedServices: React.Dispatch<React.SetStateAction<OneWayInServiceDto[]>>;
  onPrevious: () => void;
  onNext: () => void;
}

const SelectServicesStep = ({
  referTo,
  actorAlreadyHasOpportunity,
  isLoading,
  selectedServices,
  setSelectedServices,
  onPrevious,
  onNext,
}: SelectServicesStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const [showError, setShowError] = useState(false);

  return (
    <>
      <Heading level={2} className="refer-dialog--heading">
        {tOneWayIn('actionbar.Refer')}
      </Heading>
      <div className="refer-dialog--layout">
        <div className="refer-dialog--body">
          <span>
            <Trans
              i18nKey={
                actorAlreadyHasOpportunity
                  ? 'refer.dialog.actorAlreadyHasOpportunity'
                  : 'refer.dialog.chooseService'
              }
              ns="oneWayIn"
              values={{ name: referTo?.name }}
              components={{ bold: <b /> }}
            />
          </span>
          <div className="refer-dialog--scrollable margin-top--2">
            <div className="refer-dialog--compact-table">
              <ServiceTable
                selectedActor={referTo}
                selectedServices={selectedServices}
                setSelectedServices={setSelectedServices}
              />
            </div>
          </div>
        </div>
        {selectedServices.length === 0 && actorAlreadyHasOpportunity && showError && (
          <div className="refer-dialog--alert--container">
            <Alert data-color="danger" className="dialog-with-sidebar--alert">
              {tOneWayIn('refer.validation.noServiceChosen')}
            </Alert>
          </div>
        )}
        <div className="refer-dialog--action-row">
          <Button
            variant="secondary"
            onClick={() => {
              setShowError(false);
              onPrevious();
            }}
          >
            {tCommon('previous')}
          </Button>
          <Button
            loading={isLoading}
            disabled={isLoading}
            onClick={() => {
              if (selectedServices.length === 0 && actorAlreadyHasOpportunity) {
                setShowError(true);
                return;
              }
              setShowError(false);
              onNext();
            }}
          >
            {actorAlreadyHasOpportunity ? tOneWayIn('refer.dialog.sendReferral') : tCommon('next')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default SelectServicesStep;
